export default __webpack_public_path__ + "static/media/Grupo508.7f816ebf.png";